// @flow
import uuid from 'uuid';

import * as actions from './temporaryEvents';
import type { ID_TYPE } from '../types/common';

export const shout = (
  message: string,
  lifespan?: number = 3000,
  type?: number,
  data: Object,
) => actions.add(
  uuid(),
  lifespan,
  {
    message,
    type,
    ...data,
  },
  'temporalBanners',
);


export const activate = (
  id: ID_TYPE,
) => actions.trigger(
  id,
);



// WEBPACK FOOTER //
// ./src/scripts/actions/temporalBanners.js